import axios, { AxiosError } from "axios";
import * as urls from "./urls";
import { Notify } from "vant";
//import { Notification } from "element-ui";

const DEBUG = process.env.NODE_ENV !== "production";

async function sendRequest(options: any) {
  let headers = {
    "Content-Type": "application/json",
  };

  const baseUrl = "/api/";
  var url = options.url;
  //var url = "aaaa";
  if (!url.toLowerCase().startsWith("http")) {
    if (!url.startsWith("/")) url = "/" + url;
  }
  if (url.toLowerCase().startsWith("/api/")) url = url.substring(5);

  const timeout = DEBUG ? 100000 : 30000;

  const config = Object.assign(
    {},
    {
      baseURL: baseUrl,
      timeout: timeout,
      headers: headers,

      url,
      method: options.method,
      data: options.data,

      withCredentials: false,
    }
  );
  let response;
  try {
    response = await axios.request(config);
    const { data } = response;
    return data;
  } catch (err) {
    throw createError(err as any);
  }
}

function createError(err: AxiosError) {
  const { message, config, request, response } = err;
  const error = new Error(message);

  const { data, status } = response!;
  const code = data.Code;
  if (status == 400 && code == 422 && data.Message == "请刷新后重新登录!") {
    window.location.href = "http://" + window.location.host + "/login";
  } else if (status == 400 && code != 401) {
    msgbox(data.Message);
  } else if (code == 401) {
    console.log(code);
  } else if (status == 404) {
    msgbox("404 API Not Found!");
  } else {
    msgbox("服务器异常,请稍后重试");
  }

  if (message.substr(0, 7) === "timeout") {
    msgbox("请求超时");
  }
  var er = error as any
  er.Code = data.Code;
  er.Message = data.Message;

  er.config = config;
  er.request = request;
  er.response = response;
  return er;
}

function msgbox(message: string) {
  Notify({ message, type: "danger" });
}

async function sendPostRequest(url: string, data: any, config: any) {
  const requestData = {
    url: url,
    data: data,
  };

  const options = Object.assign(requestData, config, { method: "post" });
  return await sendRequest(options);
}

async function sendGetRequest(url: string, params: any, config: any) {
  if (params) {
    var ps = Object.keys(params)
      .map((e) => {
        const v = params[e];
        if (typeof v == "undefined") return null;
        return `${encodeURIComponent(e)}=${encodeURIComponent(v)}`;
      })
      .filter((e) => e)
      .join("&");
    var idx = url.indexOf("?");
    url += (idx == -1 ? "?" : "&") + ps;
  }
  const requestData = { url };
  const options = Object.assign(requestData, config, { method: "get" });
  return await sendRequest(options);
}

async function sendFromData<T = any>(url: string, params: any, form: FormData): Promise<T> {
  url = objToUrl(url, params);
  const baseUrl = urls.getApiBaseUrl();

  if (!url.toLowerCase().startsWith("http")) {
    if (!url.startsWith("/")) url = "/" + url;
  }
  if (url.toLowerCase().startsWith("/api/")) url = url.substring(5);

  const timeout = DEBUG ? 100000 : 30000;

  const config = {
    baseURL: baseUrl,
    timeout: timeout,
    withCredentials: false,
  }

  let response;
  try {
    response = await axios.post(url, form, config);
    const { data } = response;
    return data;
  } catch (err) {
    throw createError(err as any);
  }

}

function objToUrl(url: string, obj: Record<string, any>) {
  if (!obj) return url;


  var ps = Object.keys(obj)
    .map((e) => {
      const v = obj[e];
      if (typeof v == "undefined") return null;
      return `${encodeURIComponent(e)}=${encodeURIComponent(v)}`;
    })
    .filter((e) => e)
    .join("&");
  var idx = url.indexOf("?");
  url += (idx == -1 ? "?" : "&") + ps;
  return url;
}

export default {
  $post: sendPostRequest,
  $get: sendGetRequest,
  sendFromData,
  objToUrl
};
